var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('object', {
    attrs: {
      "data": _vm.chatAiSvg,
      "type": "image/svg+xml",
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.chatAiSvg,
      "alt": "Chat with AI illustration"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }